import { Table, Badge } from "react-bootstrap";

function OlaTable({ items, scoreVariant }) {
  return (
    <Table bordered hover className="mb-4" style={{ tableLayout: "fixed" }}>
      <thead>
        <tr>
          <th style={{ width: "40%" }}>OLA</th>
          <th style={{ width: "20%" }}>Voorkeur</th>
          <th style={{ width: "40%" }}>Opmerking</th>
        </tr>
      </thead>
      <tbody>
        {items.map(({ ola, pref }) => {
          const expertiseFit = pref?.expertiseFit ?? null;
          const score = pref?.passionScore;
          return (
            <tr key={ola.ID}>
              <td style={{ verticalAlign: "top" }}>{ola.name}</td>
              <td style={{ verticalAlign: "top" }}>
                {expertiseFit === 1 ? (
                  <Badge bg="secondary">Wil bijscholen</Badge>
                ) : expertiseFit === 2 ? (
                  <Badge bg="secondary">Buiten interessegebied</Badge>
                ) : score != null ? (
                  <Badge bg={scoreVariant(score)}>{score}/10</Badge>
                ) : (
                  <span className="text-muted fst-italic">Niet ingevuld</span>
                )}
              </td>
              <td className="text-muted" style={{ verticalAlign: "top" }}>{pref?.comment || ""}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}

export default OlaTable;
